import { defineComponent as n, createBlock as r, openBlock as a, unref as l, mergeProps as p, withCtx as m, createElementVNode as u } from "vue";
import { RevIcon as v } from "@ds/components/Icon";
const s = /* @__PURE__ */ n({
  name: "IconPlug",
  __name: "IconPlug",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (c, e) => (a(), r(l(v), p(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        u("path", {
          "fill-rule": "evenodd",
          d: "M9.25 3.5a.75.75 0 0 0-1.5 0v4.25H6.5A1.25 1.25 0 0 0 5.25 9v6.046a3.205 3.205 0 0 0 3.205 3.204h2.795v2.25a.75.75 0 0 0 1.5 0v-2.25h2.796a3.204 3.204 0 0 0 3.204-3.204V9a1.25 1.25 0 0 0-1.25-1.25h-1.25V3.5a.75.75 0 0 0-1.5 0v4.25h-5.5V3.5m6.296 13.25a1.705 1.705 0 0 0 1.704-1.704V9.25H6.75v5.796a1.705 1.705 0 0 0 1.705 1.704h7.09",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
